import {Language} from 'coreStore/data/configurations/types';

/**
 * Represents Language Model
 */
class LanguageModel {
	// @TODO: move rtlLanguages into LanguagesMgr and pass isRtlLanguage as a parameter for the constructor
	private rtlLanguages = ['ar'];
	isRtlLanguage: boolean;
	language: Language;

	/**
	 * @constructor
	 * @param {Language} language - language
	 */
	constructor(language: Language) {
		this.language = language;
		this.isRtlLanguage = this.rtlLanguages.includes(language.id);
	}

	/**
	 * Returns language code
	 * @returns {string}
	 * @memberof LanguageModel
	 * @example
	 * const language = LanguagesMgr.getLanguage('it');
	 * console.log(language.getLanguageCode()); // it
	 */
	getLanguageCode(): string {
		return this.language.id;
	}

	/**
	 * Checks if language is RTL
	 * @returns {boolean}
	 * @memberof LanguageModel
	 */
	getIsRtlLanguage(): boolean {
		return this.isRtlLanguage;
	}

	/**
	 * Returns language name
	 * @returns {string}
	 * @memberof LanguageModel
	 */
	getIsLtrLanguage(): boolean {
		return !this.isRtlLanguage;
	}
}

export default LanguageModel;
